import { type ReactNode } from "react";

import { ReadCoverage, ReferencesCount } from "@styled/read_coverage";

import { AssistantNotesCount } from "./assistant_notes_view";
import { type DraftWriting, assistantStepLine } from "./assistant_step_line";
import { type AssistantChats } from "./use_assistant_chats";
import { type AssistantNotes, showsAssistantLine } from "./use_assistant_notes";

// The line over the report's pages: the assistant's step now, else how much of
// the report it has read, with the references it checked and the case's notes.
export const assistantLine = (
  chats: AssistantChats,
  notes: AssistantNotes,
  writing?: DraftWriting,
): ReactNode => {
  const coverage = chats.reads.coverage;
  return (
    assistantStepLine(chats.reads, chats.thinkingSeconds, writing) ??
    (coverage && showsAssistantLine(chats, notes) && (
      <ReadCoverage
        read={coverage.read}
        total={coverage.total}
        noun="pages"
        trailing={
          <>
            <ReferencesCount count={chats.reads.referencesChecked} />
            <AssistantNotesCount notes={notes} />
          </>
        }
      />
    ))
  );
};
